// imports
import { Fragment } from 'react';
import { Box, Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';

// components
import {
  StripeTextFieldCVC,
  StripeTextFieldExpiry,
  StripeTextFieldNumber,
} from 'components/common/StripeFields';
import InputController from 'controller/InputController';

// interfaces, constants, helper
import { CARD_CVC_TEXT, CARD_EXPIRY_TEXT, CARD_HOLDER_NAME_TEXT, CARD_NUMBER_TEXT } from 'constants/constant';
import { onCardChange, onCVCChange, onExpiryChange } from 'lib/helper';

const StripeCheckoutForm = () => {
  const { setError, formState } = useFormContext();
  const { errors } = formState;
  const { card, expiry, cvc } = errors || {};

  return (
    <Fragment>
      <Box mb={4}>
        <InputController name="name" isRequired fieldType="text" title={CARD_HOLDER_NAME_TEXT} />
      </Box>
      <Box mb={4}>
        <StripeTextFieldNumber
          margin="dense"
          label={`${CARD_NUMBER_TEXT} *`}
          onChange={(event) => onCardChange(event, { setError })}
          error={Boolean(card?.message)}
          labelErrorMessage={card?.message?.toString()}
          inputProps={{
            options: {
              showIcon: true,
            },
          }}
        />
      </Box>
      <Grid container columnSpacing={4}>
        <Grid item xs={6}>
          <StripeTextFieldExpiry
            margin="dense"
            label={`${CARD_EXPIRY_TEXT} *`}
            onChange={(event) => onExpiryChange(event, { setError })}
            error={Boolean(expiry?.message)}
            labelErrorMessage={expiry?.message?.toString()}
          />
        </Grid>
        <Grid item xs={6}>
          <StripeTextFieldCVC
            margin="dense"
            label={`${CARD_CVC_TEXT} *`}
            onChange={(event) => onCVCChange(event, { setError })}
            error={Boolean(cvc?.message)}
            labelErrorMessage={cvc?.message?.toString()}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default StripeCheckoutForm;
